import React, { useRef, useState } from 'react';
import { apiFetch } from '../../api/api';

export default function PairPrintManager({ onClose, onConnected }) {
  const [code, setCode] = useState('');
  const [preview, setPreview] = useState(null);
  const [devices, setDevices] = useState([]);
  const [operation, setOperation] = useState('add');
  const [target, setTarget] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [connected, setConnected] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const approval = useRef(null);
  async function resolve(event) {
    event.preventDefault(); setBusy(true); setError('');
    try {
      const pending = await apiFetch('/api/printmanager/pairing/preview', { method:'POST', body:{pairingCode:code} });
      const choices = await apiFetch('/api/printmanager/pairing/devices');
      approval.current = crypto.randomUUID(); setDevices(choices); setPreview(pending);
    } catch { setError('Unable to find this pairing code. Check the code, expiration, and organization permissions.'); }
    finally { setBusy(false); }
  }
  async function confirm() {
    setBusy(true); setError(''); setSubmitted(true);
    try {
      await apiFetch('/api/printmanager/pairing/approve', {method:'POST',body:{sessionId:preview.sessionId,
        pairingCode:code, approvalId:approval.current, operation, ...(operation==='replace'?{targetDeviceId:target}:{})}});
      setConnected(true); onConnected?.();
    } catch { setError('Confirmation was not acknowledged. Retry the same confirmation; do not start another pairing.'); }
    finally { setBusy(false); }
  }
  return <section role="dialog" aria-modal="true" aria-label="Add Print Manager">
    <h2>Add Print Manager</h2>
    {connected ? <p>Print Manager connected.</p> : !preview ? <form onSubmit={resolve}>
      <label>Enter pairing code <input value={code} maxLength={12} autoComplete="off" onChange={e=>setCode(e.target.value)} /></label>
      <button disabled={busy || !code.trim()} type="submit">Continue</button>
    </form> : <>
      <p>Print Manager: {preview.machineName}</p><p>Pairing expires: {new Date(preview.expiresAt).toLocaleTimeString()}</p>
      <label><input type="radio" name="pair-operation" checked={operation==='add'} disabled={busy || submitted} onChange={()=>setOperation('add')} />Add as New Print Manager</label>
      <label><input type="radio" name="pair-operation" checked={operation==='replace'} disabled={busy || submitted} onChange={()=>setOperation('replace')} />Replace Existing Print Manager</label>
      {operation==='replace' && <><p>The existing identity and history stay. The old installation will lose access.</p>
        <label>Existing Print Manager <select value={target} disabled={busy || submitted} onChange={e=>setTarget(e.target.value)}>
          <option value="">Select a Print Manager</option>{devices.map(d=><option key={d.deviceId} value={d.deviceId}>{d.deviceName || d.deviceId}{d.isActive?'':' (Registered / Inactive)'}</option>)}
        </select></label></>}
      {operation==='add' && <p>Registration is free. This Print Manager will be registered inactive; activation is separate.</p>}
      <button onClick={confirm} disabled={busy || (operation==='replace'&&!target)}>Confirm</button>
    </>}
    {error && <p role="alert">{error}</p>}
    <button onClick={onClose} disabled={busy}>{connected?'Done':'Cancel'}</button>
  </section>;
}
